import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from "vuex-module-decorators";
import store from "@/store";
import { ResponseDataType } from "@/form/form.types";
import { IGroups, GroupName } from "@/entity/groups/groups.types";
import { IStoreReady } from "@/store/lib/storeSupport";

@Module({
    namespaced: true,
    name: "groups",
    store,
    dynamic: true,
})
class GroupsModule extends VuexModule implements IStoreReady {
    groups: IGroups[] = [];
    ready = false;

    @MutationAction
    async fetchAll(): Promise<{ groups: IGroups[] }> {
        const groups = await store.$repository.groups.fetchAll();
        return { groups };
    }
    @Action({ rawError: true })
    async delete(id: number): Promise<ResponseDataType> {
        return await store.$repository.groups.delete({ id: id });
        //return resp;
    }
    @Action ({ rawError: true })
    async create(data:GroupName):Promise<ResponseDataType> {
        return await  store.$repository.groups.create(data)
    }
    @Mutation
    async setReady(st: boolean) {
        this.ready = st;
    }
}

export const GroupsStore = getModule(GroupsModule);
